/** Namespace `support` — PLAT-2026-115 (bàn xử lý ticket hỗ trợ mọi app), bản gốc tiếng Việt. */
export const support = {
  title: "Hỗ trợ khách hàng",
  subtitle:
    "Ticket của mọi app trong một hộp thư. Ticket nằm ở app; hub kéo danh sách về mỗi phút, mở chi tiết là đọc trực tiếp từ app.",
  countActive: "Đang mở",
  countNeedsReply: "Chờ mình trả lời",
  countUnassigned: "Chưa giao",
  countMine: "Của tôi",
  countSlaBreached: "Quá hạn phản hồi",

  filterApp: "App",
  filterAllApps: "Tất cả app",
  filterStatus: "Trạng thái",
  filterActive: "Đang mở (chưa xong)",
  filterAll: "Tất cả",
  filterPriority: "Ưu tiên",
  filterAnyPriority: "Mọi mức",
  filterAssignee: "Người xử lý",
  filterAnyone: "Bất kỳ ai",
  filterMine: "Của tôi",
  filterUnassigned: "Chưa giao",
  filterNeedsReply: "Chỉ ticket khách đang chờ",
  searchPlaceholder: "Tìm theo mã hoặc tiêu đề",
  search: "Tìm",
  loadMore: "Xem thêm",
  loadFailed: "Không đọc được hộp thư.",
  empty: "Không có ticket nào khớp bộ lọc.",

  sourcesNotConfigured: "Chưa nối vào hộp thư: {apps}.",
  sourcesNever: "Chưa đồng bộ lần nào: {apps}.",
  sourceMisconfigured: "{app}: cấu hình trên hub sai ({error}) — hub vẫn chạy, app này tạm vắng khỏi hộp thư. Sửa biến ở Infisical rồi deploy lại bube-hq.",
  sourceError: "{app}: {error} (đồng bộ thành công gần nhất: {at})",
  never: "chưa có",

  colCode: "Mã",
  colSubject: "Tiêu đề",
  colStatus: "Trạng thái",
  colPriority: "Ưu tiên",
  colWaitingOn: "Đang chờ",
  colAssignee: "Người xử lý",
  colSla: "Phản hồi đầu",
  colActivity: "Hoạt động",
  waitingOnStaff: "Bube",
  waitingOnCustomer: "Khách",
  unassigned: "—",

  "status.open": "Chờ hỗ trợ",
  "status.in_progress": "Đang xử lý",
  "status.waiting": "Chờ khách",
  "status.resolved": "Đã xong",
  "status.closed": "Đã đóng",
  "priority.low": "Thấp",
  "priority.normal": "Thường",
  "priority.high": "Cao",
  "priority.urgent": "Khẩn",
  "category.question": "Câu hỏi",
  "category.bug": "Lỗi",
  "category.billing": "Thanh toán",
  "category.account": "Tài khoản",
  "category.feature_request": "Đề xuất",
  "category.other": "Khác",
  "sla.met": "Đúng hạn",
  "sla.pending": "Hạn {at}",
  "sla.breached": "Quá hạn",

  backToInbox: "← Hộp thư hỗ trợ",
  detailFailed: "Không đọc được ticket từ app.",
  requester: "Người gửi",
  workspace: "Workspace",
  openWorkspace: "Xem workspace",
  createdAt: "Gửi lúc {at}",
  thread: "Trao đổi",
  fromCustomer: "Khách",
  fromStaff: "Bube",
  fromSystem: "Hệ thống",
  replyPlaceholder: "Trả lời khách… (khách nhận trong app và qua email)",
  send: "Gửi trả lời",
  sendAndResolve: "Gửi & đánh dấu đã xong",
  sending: "Đang gửi…",
  sendFailed: "Gửi không được",
  closedHint: "Ticket đã đóng — khách phải mở ticket mới.",
  noReplyPermission: "Bạn chỉ có quyền xem ticket.",

  panelStatus: "Trạng thái",
  panelPriority: "Ưu tiên",
  panelAssignee: "Người xử lý",
  panelSla: "Hạn phản hồi đầu",
  takeIt: "Nhận việc",
  unassign: "Bỏ giao",
  nobody: "Chưa giao",
  saveFailed: "Lưu không được",

  notes: "Ghi chú nội bộ ({count})",
  notesHint: "Khách không thấy ghi chú này.",
  notePlaceholder: "Ghi chú cho đồng nghiệp…",
  addNote: "Thêm ghi chú",
  noNotes: "Chưa có ghi chú.",
} as const;
